import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconSparkle = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M18 3a1 1 0 0 1 1 1 1 1 0 0 0 1 1 1 1 0 1 1 0 2 1 1 0 0 0-1 1 1 1 0 1 1-2 0 1 1 0 0 0-1-1 1 1 0 1 1 0-2 1 1 0 0 0 1-1 1 1 0 0 1 1-1M9 5a1 1 0 0 1 1 1 5 5 0 0 0 5 5 1 1 0 1 1 0 2 5 5 0 0 0-5 5 1 1 0 1 1-2 0 5 5 0 0 0-5-5 1 1 0 1 1 0-2 5 5 0 0 0 5-5 1 1 0 0 1 1-1m0 4.606A7 7 0 0 1 6.606 12 7 7 0 0 1 9 14.394 7 7 0 0 1 11.394 12 7 7 0 0 1 9 9.606m7.707 7.101A1 1 0 0 0 17 16a1 1 0 1 1 2 0 1 1 0 0 0 1 1 1 1 0 1 1 0 2 1 1 0 0 0-1 1 1 1 0 1 1-2 0 1 1 0 0 0-1-1 1 1 0 1 1 0-2 1 1 0 0 0 .707-.293"
            clipRule="evenodd"
        />
    </svg>
);
